import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import './EventConfig.css';

interface EventConfigProps {
  show: boolean;
  onClose: () => void;
}

const EventConfig: React.FC<EventConfigProps> = ({ show, onClose }) => {
  const [eventCode, setEventCode] = useState('');
  const [currentEvent, setCurrentEvent] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<'success' | 'error'>('success');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show && window.electronAPI) {
      window.electronAPI.getEventCode().then((code: string) => {
        if (code) {
          setEventCode(code);
          setCurrentEvent(code);
        }
      });
    }
  }, [show]);

  const showMessage = (text: string, type: 'success' | 'error') => {
    setMessage(text);
    setMessageType(type);
    setTimeout(() => setMessage(''), 5000);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const code = eventCode.trim();

    if (!code) {
      showMessage('Por favor ingresa un código de evento', 'error');
      return;
    }

    setLoading(true);

    try {
      await window.electronAPI.saveEventCode(code);
      showMessage('✓ Código guardado exitosamente. Descargando datos...', 'success');
      setCurrentEvent(code);

      // Iniciar actualización de posters
      await window.electronAPI.triggerPostersUpdate();

      setTimeout(() => {
        onClose();
      }, 2000);
    } catch (error: any) {
      showMessage('✗ Error al guardar: ' + error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>⚙️ Configuración del Evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-3">
          Ingresa el código privado del evento para descargar y visualizar los e-posters correspondientes.
        </p>

        {currentEvent && (
          <div className="alert alert-info">
            Evento actual: <strong>{currentEvent}</strong>
          </div>
        )}

        {message && (
          <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'}`}>
            {message}
          </div>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Código del Evento</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ej: slep2025"
              value={eventCode}
              onChange={(e) => setEventCode(e.target.value)}
              required
              autoComplete="off"
            />
          </Form.Group>

          <div className="d-flex gap-2">
            <Button variant="secondary" onClick={onClose} disabled={loading}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar y Descargar'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EventConfig;
